import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from '../store/store';
import { Box } from '@mui/material';
import ChatInterface from '../components/Chat/ChatInterface';
import styles from './Home.module.css';
import { fetchProjects } from '../store/projectSlice';
import { Button } from '@mui/material';

const Home: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { selectedProject, error } = useSelector((state: RootState) => state.projects);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);

  useEffect(() => {
    const handleResize = () => {
      setWindowHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
    dispatch(fetchProjects());

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, [dispatch]);

  if (error) {
    return (
      <div className={styles.errorContainer}>
        <div>Unable to connect to server. Please check if the server is running.</div>
        <Button
          variant="outlined"
          color="error"
          onClick={() => dispatch(fetchProjects())}
        >
          Retry Connection
        </Button>
      </div>
    );
  }

  if (!selectedProject) {
    return (
      <div className={styles.noProjectMessage}>
        Please select a project from the sidebar to start chatting.
      </div>
    );
  }

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      height: `${windowHeight - 88}px`,
      width: '100%',
      minWidth: '330px',
      overflow: 'auto'
    }}>
      <ChatInterface windowHeight={windowHeight} />
    </Box>
  );
};

export default Home;
